import { DiscountsPrefigureDiscountResult } from "@springtree/eva-services-core";
import Link from "next/link";
import { useTranslations } from "next-intl";

import IconBirthday from "@/icons/icon-birthday";
import Icon from "~/components/common/icon";
import myaccount from "~/components/common/myaccount.module.scss";
import appRoutes from "~/utils/app-routes";
import Constants from "~/utils/constants";

import styles from "./birthday-card.module.scss";

type Props = {
  promo: DiscountsPrefigureDiscountResult;
};

export default function BirthdayCard(props: Props) {
  const t = useTranslations();

  return (
    <>
      <div className={myaccount.myaccountCard}>
        <div className={styles.container}>
          <Icon icon={IconBirthday} />
          <div className={styles.wrapperText}>
            <p className={styles.title}>{t("generic.your_birthday")}</p>
            <p className={styles.description}>
              {t.rich("generic.celebrate_your_birthday", {
                strong: (chunks) => <strong className={styles.bold}>{chunks}</strong>,
                br: () => <br />,
              })}
            </p>
          </div>

          {/* on click go to cart and apply couupon (if available) */}
          {/* IsAlreadyApplied false even if the coupon is correctly applied to the order */}
          <Link
            href={`${appRoutes.CART}/?${Constants.COUPON_KEY}=${props.promo.AvailableUserCoupons?.[0].Code}`}
            className={styles.link}
          >
            {t("generic.get_my_birthday_gift_now")}
          </Link>
        </div>
      </div>
    </>
  );
}
